import { render } from "./Breadcrumb.vue?vue&type=template&id=031e53ea&ts=true"
import script from "./Breadcrumb.vue?vue&type=script&lang=ts"
export * from "./Breadcrumb.vue?vue&type=script&lang=ts"

import "./Breadcrumb.vue?vue&type=style&index=0&id=031e53ea&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__